import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { AppButton } from '@core/components/AppButton'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'

export const Reseted = () => {
    const { t } = useTranslation()
    const { appTheme } = useAppTheme()
    return (
        <Flex flexDirection={'column'}>
            <Text fontSize={'xs'} color={'text.thirdly'} mb={1}>
                {t('6593')} 4 {t('1165')} 4
            </Text>
            <Text fontSize={'2xl'} color={'text.main'} fontWeight={'semibold'} mb={4}>
                {t('6629')}
            </Text>
            <Text fontSize={'14px'} color={'#404040'} mb={6}>
                {t('6630')}.
            </Text>
            <AppButton
                translate="no"
                title={t('6631')}
                variant={'primary'}
                alignSelf={'end'}
                w={'120px'}
                h={'44px'}
                onClick={() => (location.href = '/login')}
            />
            {/* <Button
                variant={'primary'}
                alignSelf={'end'}
                w={'120px'}
                h={'44px'}
                onClick={() => (location.href = '/login')}
                bg={appTheme ? `#${appTheme.newSettings.general.ButtonBackground}` : 'btn.primary'}
                color={appTheme ? `#${appTheme.newSettings.general.ButtonText}` : 'text.white'}
            >
                {t('6631')}
            </Button> */}
        </Flex>
    )
}
